import { GiDeadHead } from 'react-icons/gi';
import Button from '../Button/Button';

const ErrorFallback = ({ resetErrorBoundary }) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: 'black',
        flexDirection: 'column',
        gap: '20px',
      }}
    >
      <GiDeadHead style={{ fontSize: '300px', color: 'red' }} />
      <p style={{ color: 'red', fontSize: '24px', margin: 0 }}>
        Something went wrong...
      </p>
      <p style={{ color: 'cyan', fontSize: '24px', margin: 0 }}>
        Let's reload, shall we?
      </p>
      <Button
        type={'smallSquare roll'}
        title="reLOad"
        handleClick={resetErrorBoundary}
      ></Button>
    </div>
  );
};

export default ErrorFallback;
